import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap';
import { YesNoConfirmation1Component } from '../modal-pop-ups/yes-no-confirmation1/yes-no-confirmation1.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-ar-assigned',
  templateUrl: './ar-assigned.component.html',
  styleUrls: ['./ar-assigned.component.scss']
})
export class ArAssignedComponent implements OnInit {
  private notifier: NotifierService;
  filters_form: FormGroup;
  isShow: boolean = false;
  searchText;
  stations;
  arAssingedTrans = [];
  activeTab;
  constructor(
    private spinner: NgxSpinnerService,  
    notifierService: NotifierService,
    private arService: ArService,
    private modalService: BsModalService,
    private router: Router
    ) {
      this.notifier = notifierService;
   
     }

  ngOnInit() {
    this.getAssignedTransactions();
  }

  ManualClosure(id){
    //console.log(id)
    const initialState = {
      title: `Do you want to manually close the payment for the Reservation ${id} ?`,
      currentTabIndex: 1
    };
    const modalRef = this.modalService.show(YesNoConfirmation1Component, { initialState });
    modalRef.setClass('modal-lg modal-dialog-centered modal-dialog-scrollable');
    modalRef.content.event.subscribe(res => {
      //console.log(res)
      if (res.data) {
       // console.log(res.data)
        let resIdsList = [];
        resIdsList.push(id);
       let postData =  {
          "resIds": resIdsList
                   }
      this.spinner.show();
       this.arService.ManualClosurePayment(postData).subscribe(resData => { 
        this.getAssignedTransactions();
        this.spinner.hide();
        this.notifier.notify('success', 'Payment has been closed manually.');
        setTimeout(() => {
          this.reload('home/ar-dashboard');
        }, 1000);
      },(error:any)=>{
        this.spinner.hide();
        console.log(error);
      });
      } else {
        modalRef.hide()
      }
    })
  }

  getAssignedTransactions(payload = {}) {
    this.searchText = ''
    this.spinner.show();
    this.arService.getAllAssignedTransactions(payload).subscribe(res => {
      this.spinner.hide();
      if(res['status'] && res['result'].length > 0 ){
        this.arAssingedTrans = res['result'];
      } else {
        this.arAssingedTrans = []
      }
    });
    if(Object.keys(payload).length === 0) this.isShow = false;
  }
  captureCCardAmount(data){
    const ccData = {
      RESID : data.RESID,
      TXREFNUM :data.TXREFNUM,
      CURRENCY_FLAG:data.CURRENCY_FLAG
    }
    this.spinner.show();
    this.arService.multiACTransactionForCC(ccData).subscribe(async res => {
      this.spinner.hide();
      if(res['status']){
        this.notifier.notify('success', 'Payment captured successfully');
      //  console.log(res);
        this.getAssignedTransactions();
      }else{
        this.notifier.notify('warning','Payment capture faild');
      }
    });
  }

  async reload(url: string): Promise<boolean> {
    await this.router.navigateByUrl('.', { skipLocationChange: true });
    return this.router.navigateByUrl(url);
  }

  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }
  showFilter() {
    this.isShow = !this.isShow
  }
  exportExcel() {
    const exportData = this.arAssingedTrans.map(trans => ({
      'Res ID': trans.RESID,
      'Action': trans.TRANSACTION_TYPE ? (trans.TRANSACTION_TYPE === 'Credit Card' ? 'Payment - Credit Card' : 'Payment - Cheque') : '',
      'Res Type': trans.RES_TYPE,
      'Res Status': trans.RESSTATUS,
      'Billing Status': trans.GREET_SERVICE_BACKOFFICE_STATUS || '',
      'Currency': trans.CURRENCY_FLAG,
      'Station': trans.STATION,
      'Res Start Date': trans.STARTDT ? moment(trans.STARTDT).format('DD/MM/YYYY') : '',
      'Net Terms': trans.NET_TERMS,
      'Invoice ID': trans.INVOICE_RECEIPT_ID,
      'Sub Total': trans.TRANSACTION_SUBTOTAL,
      'Tax': trans.TRANSACTION_TAXES,
      'Total Due': trans.TRANSACTION_TOTAL,
      'Customer Name': trans.CONTACT_NAME,
      'Customer Bill To (Company Name)': trans.COMPANY_NAME,
      'Print Invoice': trans.PRINTED == 1 ? 'Yes' : 'No',
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Report': worksheet },
      SheetNames: ['Report']
    };

    XLSX.writeFile(workbook, 'To_Be_Billed_Transactions.xlsx');
  }
}
